module.exports = __webpack_public_path__ + "static/media/executiveFunctions.288ae54c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/executiveFunctions.svg
// module id = 1462
// module chunks = 0